/**
 * Batch #14.73 — Context pour custom breadcrumb trail.
 *
 * Permet aux pages détail (Master, Fiscal, Immeuble) de fournir un fil d'Ariane
 * personnalisé qui remplace le fil auto-généré depuis l'URL.
 *
 * Usage :
 *   const { setTrail } = useBreadcrumb();
 *   useEffect(() => {
 *     setTrail([
 *       { label: "Hub Clients", href: "/admin/clients-hub" },
 *       { label: "Master — Registre", href: "/admin/masters" },
 *       { label: "Jean Dupont + Marie Tremblay" },  // dernier item = pas de href
 *     ]);
 *     return () => setTrail(null); // cleanup à l'unmount
 *   }, [master]);
 */
import { createContext, useCallback, useContext, useState } from "react";

const BreadcrumbContext = createContext({
  trail: null,
  setTrail: () => {},
});

export function BreadcrumbProvider({ children }) {
  const [trail, setTrailState] = useState(null);
  const setTrail = useCallback((newTrail) => setTrailState(newTrail), []);
  return (
    <BreadcrumbContext.Provider value={{ trail, setTrail }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumb() {
  return useContext(BreadcrumbContext);
}
